.filled {
  width: 20px;
  height: 20px;
  padding: 2px;
  margin-right: 4px;
  border-radius: 8px;
  background: var(--bc-color-primary);
  vertical-align: middle;
  fill: var(--bc-color-white);
}
